import { AbstractCommand } from 'src/models/command';

class DeleteTheMailTemplateOrDraftCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_DeleteTheMailTemplateOrDraftCommand';

	public constructor(draftOrTemplateId: string, type: string) {
		super();
		this.parameters = {
			draftOrTemplateId: draftOrTemplateId,
			type: type,
		};
	}
}

export { DeleteTheMailTemplateOrDraftCommand };
